export default __webpack_public_path__ + "static/media/bandeira_au.80129b63.png";